<template>
  <section>
    <div class="leftTab" v-if="role === 'self'">
      <div class="item" @click="clickTab('article')" :class="activeTab === 'article'?'active':''">
        <i class="iconfont icon-detail"></i>&nbsp;&nbsp;我的帖子
      </div>
      <div class="item" @click="clickTab('info')" :class="activeTab === 'info'?'active':''">
        <i class="iconfont icon-account"></i>&nbsp;&nbsp;我的资料
      </div>
      <div class="item" @click="clickTab('msg')" :class="activeTab === 'msg'?'active':''">
        <i class="iconfont icon-comments"></i>&nbsp;&nbsp;我的消息
      </div>
      <div class="item" @click="clickTab('collect')" :class="activeTab === 'collect'?'active':''">
        <i class="iconfont icon-collection"></i>&nbsp;&nbsp;我的收藏
      </div>
    </div>
    <div class="leftTab" v-if="role === 'other'">
      <div class="item" @click="clickTab('article')" :class="activeTab === 'article'?'active':''">
        <i class="iconfont icon-detail"></i>&nbsp;&nbsp;他的帖子
      </div>
      <div class="item" @click="clickTab('info')" :class="activeTab === 'info'?'active':''">
        <i class="iconfont icon-account"></i>&nbsp;&nbsp;他的资料
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: String,
      default: 'article'
    },
    role: {
      type: String,
      default: 'self'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    clickTab: function (tab) {
      this.$emit('changeTab', tab)
    }
  },
  mounted: function (s) {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style scoped>
.leftTab {
  width: 230px;
  float: left;
  background-color: #FFFFFF;
  margin-bottom: 20px;
}
.leftTab .item {
  height: 80px;
  line-height: 80px;
  border-bottom: 1px solid #F0F0F0;
  cursor: pointer;
}
.leftTab .active {
  color: #05b570;
}
.icon-detail{
  font-size: 14px;
}
.icon-account,
.icon-comments,
.icon-collection{
  font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/base/leftTab.vue